import * as React from "react"

import { isNumber } from "../../../../../../util/Strings"

import Button from "../Button"
import UnavailableLink from "../UnavailableLink"
import { IGlobalActionsController } from "../../../../../../global"

declare let globalActionsController: IGlobalActionsController

interface Props {
    attributes: Record<string, string>
    label: string
    linkParameters: string[]
}

export const ReportInternalLink = ({
    attributes,
    label,
    linkParameters,
}: Props): JSX.Element => {
    if (
        linkParameters.length === 3 &&
        linkParameters[1] === "execute" &&
        isNumber(linkParameters[2])
    ) {
        // REPORT.EXECUTE.[REPORTID] => EXECUTES THE GIVEN REPORT
        const onClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
            event.stopPropagation()
            globalActionsController.executeReport(linkParameters[2])
        }

        return (
            <Button attributes={attributes} label={label} onClick={onClick} />
        )
    }

    return <UnavailableLink attributes={attributes} label={label} />
}

export default ReportInternalLink
